// extracted by mini-css-extract-plugin
export default {"wrapper":"selectLanguage-module__wrapper--bSIc8","lang":"selectLanguage-module__lang--uKy2Z"};